module.exports = __webpack_public_path__ + "media/bell.386f952c.mp3";